import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type InventoryQuickbooksFlatTeamSettingGroupId =
  | "inventory_quickbooks.quickbooks_connection"
  | "inventory_quickbooks.quickbooks_sync_settings";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.ims",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Connection and sync behavior between Redo and the team's QuickBooks Online accounting.",
};

export const InventoryQuickbooksFlatTeamSettingGroups = [
  {
    id: "inventory_quickbooks.quickbooks_connection",
    title: "QuickBooks connection",
    description:
      "Connects this store to QuickBooks Online so Redo can send accounting data. Disconnecting stops all QuickBooks syncing.",
    productArea: "fulfillment",
    access: directMerchantAccess(
      SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: {
      type: "settings",
      path: "inventory-management/quickbooks",
    },
    synonyms: ["quickbooks connection", "inventory quickbooks"],
  },
  {
    id: "inventory_quickbooks.quickbooks_sync_settings",
    title: "QuickBooks sync settings",
    description:
      "What Redo sends to QuickBooks Online: whether saving a purchase order creates or updates a Bill, and whether bill lines are item-based or account-based. Changes take effect on the next save.",
    productArea: "fulfillment",
    access: directMerchantAccess(
      SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: {
      type: "settings",
      path: "inventory-management/quickbooks",
    },
    synonyms: ["quickbooks sync settings", "inventory quickbooks"],
  },
] as const satisfies readonly SettingGroupDefinition<InventoryQuickbooksFlatTeamSettingGroupId>[];
